module.exports = __webpack_public_path__ + "img/service_image5.23523baf.jpg";